// Fast (Lavash POS) bazasidan eksport so'rovi (Q-034). Faqat o'qiydi: PIN, parol va savdo tarixi olinmaydi.
// Restoran egasi o'z Supabase loyihasida SQL Editor'da ishga tushiradi; natijani "Fast'dan import"ga beradi.
export const FAST_EXPORT_SQL = `-- ============================================================================
-- FAST (Lavash POS) → ONE POS: ma'lumotlarni eksport qilish
--
-- Qayerda: fast ishlayotgan Supabase loyihasi → SQL Editor → shu matnni to'liq qo'yib "Run".
-- Nima qiladi: FAQAT O'QIYDI. Hech narsani o'zgartirmaydi va o'chirmaydi.
-- Natija: bitta katakda "onepos_export" — uni yuklab oling (Export → CSV) yoki katakni nusxalab .txt faylga
-- saqlang va ONE POS'ga yuboring. Faylda PIN, parol, kalit va savdo tarixi YO'Q.
-- ============================================================================

-- Jadval bo'lmasa (eski versiya) — bo'sh ro'yxat; ustunlar qanday bo'lsa, shunday olinadi.
create or replace function pg_temp.onepos_rows(p_table text, p_drop text[] default '{}', p_where text default 'true')
returns jsonb language plpgsql as $$
declare r jsonb;
begin
    if to_regclass('public.' || p_table) is null then
        return '[]'::jsonb;
    end if;
    execute format('select coalesce(jsonb_agg(to_jsonb(t) - %L::text[]), ''[]''::jsonb) from public.%I t where %s',
                   p_drop, p_table, p_where)
    into r;
    return r;
end $$;

with b as (
    select * from public.branches where is_active order by created_at limit 1
)
select jsonb_build_object(
    'source', 'fast',
    'version', 1,
    'exported_at', now(),
    'branch', (select to_jsonb(b) - array['id', 'code'] from b),
    'categories', pg_temp.onepos_rows('categories'),
    'products', pg_temp.onepos_rows('products'),
    'branch_products', pg_temp.onepos_rows('branch_products', '{}', format('branch_id = %L', (select id from b))),
    'modifier_groups', pg_temp.onepos_rows('modifier_groups'),
    'modifiers', pg_temp.onepos_rows('modifiers'),
    'product_modifier_groups', pg_temp.onepos_rows('product_modifier_groups'),
    'category_modifier_groups', pg_temp.onepos_rows('category_modifier_groups'),
    'raw_materials', pg_temp.onepos_rows('raw_materials'),
    'recipes', pg_temp.onepos_rows('recipes'),
    'stock', pg_temp.onepos_rows('branch_stock', '{}', format('branch_id = %L', (select id from b))),
    'zones', pg_temp.onepos_rows('zones', '{}', format('branch_id = %L', (select id from b))),
    'tables', pg_temp.onepos_rows('tables', '{}', format('branch_id = %L', (select id from b))),
    'staff', pg_temp.onepos_rows('staff', array['pin_hash', 'pin_fingerprint', 'failed_attempts', 'locked_until'],
                                 format('branch_id = %L', (select id from b))),
    'staff_meal_rules', pg_temp.onepos_rows('staff_meal_rules', '{}', format('branch_id = %L', (select id from b)))
)::text as onepos_export;
`;
